import React from 'react';
import PageLayout from '../../componentsV2/PageLayout/PageLayout';

const EmailVerificationSuccessPage = () => {
  return (
    <PageLayout
      pageTitle="Email Verified"
      shouldShowPageHeader
      shouldShowBreadcrumbs={false}
    >
      <div className="my-4 pl-2">
        <p className="text-lg text-vamos-dark mb-4">
          Your email address has been successfully updated.
        </p>

        <p className="text-sm text-vamos-gray">
          You can now close this window.
        </p>
      </div>
    </PageLayout>
  );
};

export default EmailVerificationSuccessPage;
